export default __webpack_public_path__ + "static/media/Slide43.3808bc1d.PNG";